import { render, staticRenderFns } from "./Clicksign.vue?vue&type=template&id=0f854eb6&scoped=true&"
import script from "./Clicksign.vue?vue&type=script&lang=js&"
export * from "./Clicksign.vue?vue&type=script&lang=js&"
import style0 from "./Clicksign.vue?vue&type=style&index=0&id=0f854eb6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f854eb6",
  null
  
)

export default component.exports